import { createAsyncThunk } from '@reduxjs/toolkit';
import { PlaidApi, GetSavingsAccountsResponse } from 'api/PlaidApi';

export const createGetSavingsAccountsThunk = (api: PlaidApi) =>
  createAsyncThunk('yourGoal/getSavingsAccounts', async (applicationId: string, thunkApi) => {
    try {
      const response: GetSavingsAccountsResponse = await api.getSavingsAccounts(applicationId);
      return response;
    } catch (error: any) {
      const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
      return thunkApi.rejectWithValue(payload);
    }
  });
